export default __webpack_public_path__ + "static/media/icon_elight_exit.e328190d.png";